import React, { Component } from 'react'
import {
  AntennaBottomControl,
  Box,
  Button,
  Card,
  CustomSpacer,
  Icons,
  InfoCard,
  InfoModal,
  Input,
  KeyValueRow,
  Page,
  Placeholder,
  Select,
  SelectItemModal,
  Spacer,
  Tab,
  TextBox,
} from 'components'
import AppStore from 'AppStore'
import { __, T } from 'translations/i18n'
import styled from '@emotion/styled'
import { askUserConfirmation, closeModal, openModal, showToast, sleep } from 'shared/utils'
import {
  Causal,
  CQCounters,
  CQLot,
  CQSerie,
  CQTag,
  ProductionOrderRow,
  QualitySheet,
  QuantitiesCQDto,
  TestingSheet,
} from 'api/types'
import RemoteConfig from 'shared/RemoteConfig'
import EncodingsCQ from 'api/EncodingsCQ'
import Sounds from 'shared/Sounds'
import SeriesNotesModal from 'components/modals/SeriesNotesModal'
import DataDogLogger from 'shared/DataDogLogger'
import QualitySheetModal from 'components/modals/QualitySheetModal'
import QualityControlAgent from './QualityControlAgentNew'
import QualityControlCausal from '../../components/QualityControlCausal'
import QualityControlQuantity from '../../components/QualityControlQuantity'
import _ from 'lodash'
import QualityProvider, { CounterContainer, Counter, TagReadBox, TagReadPlaceholder } from './QualityProvider'

interface State {
  showQualitySheetModal: boolean
  options: { value: string; label: string; active: boolean }[]
  isReading: boolean
  isVerifing: boolean
  isWriting: boolean
  errorSerie: any
  serie?: CQSerie
  serieCode: string
  counters?: CQCounters
  item?: any
  tag?: CQTag
  warningText?: string
  isSerieSet: boolean
  isActionInProgress: boolean
  causal: Causal[]
  selectedCausal?: Causal
  qualitySheetData?: QualitySheet
  lastSearchedSerieCode?: string
  showScartoModal: boolean
  hideStartReaderButton: boolean
  lots?: CQLot[]
  showSeriesNotesModal: boolean
  testingSheetData?: TestingSheet
  testedPieces: number
  inspectorTested?: number
  discarded?: number
  toBeTested?: number
  isVAS: boolean
  lastReadedTag?: string
  causalsCount: number
  quantityToAdvance: Map<string, number>
  causalQuantityMap: Map<string, Map<string, number>>
  originalQuantity: Map<string, number>
  serieHasTag?: boolean
  lotQuantity: number
  rows: ProductionOrderRow[]
  encodable?: QuantitiesCQDto[]
  currentProductQuantity?: number
}

export default class QualityControlInspector extends Component<{}, State> {
  state: State = {
    showQualitySheetModal: false,
    options: [{ value: 'COLLAUDO', label: __(T.labels.testing), active: true }],
    isReading: false,
    isVerifing: false,
    isWriting: false,
    causal: [],
    errorSerie: '',
    isSerieSet: false,
    isActionInProgress: false,
    showScartoModal: false,
    hideStartReaderButton: false,
    showSeriesNotesModal: false,
    isVAS: false,
    lastReadedTag: undefined,
    testedPieces: 0,
    causalsCount: 0,
    causalQuantityMap: new Map<string, Map<string, number>>(),
    quantityToAdvance: new Map<string, number>(),
    originalQuantity: new Map<string, number>(),
    lotQuantity: 0,
    serieCode: '',
    rows: [],
  }
  tipoCQ = AppStore.defaultPlace?.attributes?.['tmr.ferragamo.integration.fast.series.tipocq']
  isWSM2 = AppStore.defaultPlace?.attributes?.['tmr.ferragamo.integration.fast.series.wsm2.worker'] === 'S'
  inputRef = React.createRef<HTMLInputElement>()
  inputRefScarti = React.createRef<HTMLInputElement>()
  operation = RemoteConfig.getOperationConfig<any>('quality-control-inspector')
  isPelletteria = (AppStore.defaultPlace?.attributes as any)?.categoryType === 'P'

  clearInputRef = (ref: React.RefObject<HTMLInputElement>) => {
    if (ref && ref.current) {
      ref.current.value = ''
    }
  }

  async componentDidMount() {
    await QualityProvider.commonComponentDidMount(this.stopReader, this.isPelletteria, (causal) =>
      this.setState({ causal })
    )
  }

  async componentWillUnmount() {
    await this.stopReader()
  }

  clearStatus = async () => {
    const { isSerieSet, serieHasTag } = this.state
    await this.stopReader()
    this.clearInputRef(this.inputRef)
    this.setState({
      showQualitySheetModal: false,
      options: isSerieSet
        ? serieHasTag
          ? [
              { value: 'COLLAUDO', label: __(T.labels.testing), active: true },
              { value: 'SCARTO', label: __(T.labels.discard), active: false },
              { value: 'CANCELLAZIONE', label: __(T.labels.delete), active: false },
            ]
          : [
              { value: 'COLLAUDO', label: __(T.labels.testing), active: true },
              { value: 'SCARTO', label: __(T.labels.discard), active: false },
            ]
        : [],
      isReading: false,
      isVerifing: false,
      isWriting: false,
      errorSerie: '',
      isSerieSet: false,
      isActionInProgress: false,
      qualitySheetData: undefined,
      serie: undefined,
      counters: undefined,
      item: undefined,
      tag: undefined,
      warningText: undefined,
      showScartoModal: false,
      lots: undefined,
      testingSheetData: undefined,
      isVAS: false,
      causalQuantityMap: new Map<string, Map<string, number>>(),
      causalsCount: 0,
      testedPieces: 0,
      serieCode: '',
    })
  }

  toggleQualitySheetDetail = () => {
    const { showQualitySheetModal, serie } = this.state
    DataDogLogger.addAction('toggleQualitySheetDetail', {
      serie: serie ?? 'serie is undefined',
      show: !showQualitySheetModal,
    })
    this.setState({ showQualitySheetModal: !showQualitySheetModal })
  }

  changeOptions = async (selectedOption: string) => {
    const { serieHasTag, options, serieCode, causalQuantityMap, causalsCount, quantityToAdvance } = this.state
    const oldOption = options.find((opt) => opt.active)
    if (oldOption?.value === selectedOption) return
    if (causalsCount > 0) {
      if (selectedOption === 'COLLAUDO' && oldOption?.value === 'SCARTO' && !serieHasTag) {
        if (await askUserConfirmation(__(T.messages.confirm_change_option), __(T.messages.serie_clear_causals))) {
          this.setState({ causalQuantityMap: new Map<string, Map<string, number>>(), causalsCount: 0 })
        } else {
          return
        }
      }
    }
    options.map((option) => {
      option.active = option.value === selectedOption
      return option
    })
    this.setState({ options })
    if (!serieHasTag) {
      if (this.isPelletteria) {
        let totalCausals = 0
        Array.from(causalQuantityMap.entries()).forEach(([, value1]) => {
          Array.from(value1.entries()).forEach(([key2]) => {
            totalCausals += value1.get(key2) ?? 0
          })
        })
        quantityToAdvance.set(serieCode, (quantityToAdvance.get(serieCode) ?? 0) + totalCausals)
      } else {
        if (selectedOption === 'COLLAUDO') {
          Array.from(causalQuantityMap.entries()).forEach(([key1, value1]) => {
            let somma = 0
            Array.from(value1.entries()).forEach(([key2]) => {
              somma += value1.get(key2) ?? 0
            })
            const value = (quantityToAdvance.get(key1) ?? 0) + somma
            if (value > 0) quantityToAdvance.set(key1, value)
          })
        }
      }
      this.setState({
        causalQuantityMap: new Map<string, Map<string, number>>(),
        causalsCount: 0,
        quantityToAdvance,
      })
    }
  }

  getUpdatedCounters = async (code?: string) => {
    const { serie } = this.state
    const serieCode = code ?? serie!.code
    const counters: CQCounters = await EncodingsCQ.getEncodable(serieCode)
    if (!counters) throw Error(__(T.error.counters_error))
    return counters
  }

  //funzione chiamata quando si cerca una serie
  searchSerie = async (code: string) => {
    await this.getUpdatedSerie(code)
  }

  getUpdatedSerie = async (code: string, startReader = true) => {
    try {
      await this.stopReader()
      code = code.toUpperCase()
      const { serie } = this.state
      if (this.isPelletteria && code.length !== 10) throw new Error(__(T.error.serie_code_10_characters))
      if (!this.isPelletteria && code.length !== 14 && code.length !== 17)
        throw new Error(__(T.error.serie_code_14_characters))
      let newSerie
      if (this.tipoCQ === 'CENTO') {
        newSerie = await EncodingsCQ.getSerieInfoInspector(code, this.operation)
      } else {
        newSerie = await EncodingsCQ.getCQCustomProductionOrder(code, this.operation)
      }

      if (!newSerie) throw new Error(__(T.error.serie_not_found))
      if (newSerie.worker.code !== AppStore.defaultPlace?.code) throw new Error(__(T.error.serie_wrong_place))
      if (serie && newSerie?.code !== serie?.code) {
        if (
          !(await askUserConfirmation(
            __(T.messages.serie_change_confirm),
            __(T.messages.serie_close_product_not_associated)
          ))
        )
          return false
        await this.closeLotto()
      }

      let row
      newSerie.rows.sort((a, b) => a.product.size.value - b.product.size.value)
      if (this.isPelletteria) row = newSerie.rows[0]
      else {
        row = newSerie.rows.find((r) => r.rowCode === code) as any
        // fallback per codici (vecchi) serie 14 caratteri
        if (!row && code.length === 14) {
          const barcodeTo17chars = `${code.slice(0, 4)}000${code.slice(4)}`
          row = newSerie.rows.find((r) => r.rowCode === barcodeTo17chars) as any
        }
      }

      if (!row?.product) throw Error(__(T.error.fit_size_not_found))
      let isVAS = false
      const serieHasTag: boolean = newSerie.serieHasTag
      if (newSerie.availableQuantity === 0 && this.isWSM2 && serieHasTag)
        showToast({
          title: __(T.placeholder.attention),
          description: __(T.misc.encoded_items_on_serie),
          status: 'warning',
        })
      if (newSerie && newSerie.customerOrder && newSerie.customerOrder === '24S1') isVAS = true

      const qualitySheetData = (
        await EncodingsCQ.getQualitySheet(
          newSerie.qualityCode || '',
          newSerie?.worker.code,
          row?.product?.style?.value ?? ''
        )
      )[0]
      const testingSheetData = (await EncodingsCQ.getTestingSheet(newSerie.id))[0]
      const counters = await this.getUpdatedCounters(newSerie.code)
      if (!counters) throw new Error(__(T.error.counters_error))
      const lotCounts = counters!.itemStatusCounts.lotCounts
      let filteredLots: CQLot[]
      if (serie && newSerie?.code === serie?.code) {
        filteredLots = newSerie.lots!.filter(
          (lot) => serie.data.currentLotData!.map((currentLot) => currentLot.id).indexOf(lot.id) !== -1
        )
      } else {
        filteredLots = newSerie.lots!.filter(
          (lot) => lot.status === 'INSPECTED_2' || lot.status === 'READY_INSPECTION_2'
        )
        if (filteredLots.length === 0) throw new Error(__(T.error.no_lot_to_be_inspected))
        if (filteredLots.length > 1) filteredLots = await this.showSelectLotsModal(filteredLots, lotCounts)
        await EncodingsCQ.changeStatusLottiToInspected({
          orderId: newSerie!.code,
          lotIds: filteredLots!.map(({ id }) => id),
        })
      }
      const filteredLotsToInterrupt = filteredLots!.filter((lot) => lot.items.length === 0)
      if (filteredLotsToInterrupt.length > 0 && this.tipoCQ === 'CAMP_LOTTI') {
        await this.showInterruptModal(filteredLotsToInterrupt, newSerie.id)
        filteredLots = filteredLots!.filter((lot) => lot.items.length !== 0)
      }
      const selectedLotsCounters = lotCounts.filter(
        ({ lotId }) => filteredLots!.map(({ id }) => id).indexOf(lotId) !== -1
      )
      let testedPieces = 0
      let inspectorTested = 0
      let discarded = 0
      let toBeTested = 0
      let total = 0
      for (let i = 0; i < selectedLotsCounters.length; i++) {
        testedPieces += selectedLotsCounters[i].tested!
        inspectorTested += selectedLotsCounters[i].inspectorTested
        discarded += selectedLotsCounters[i].discardedNR! + selectedLotsCounters[i].discarded!
        toBeTested += selectedLotsCounters[i].toBeTested!
        total += selectedLotsCounters[i].total!
      }
      const newSerieFormatted: CQSerie = {
        id: newSerie.id,
        code: newSerie.code,
        productId: row.product.id,
        data: {
          values: {
            'Tag/Cal': `${row.product.size.value}/${row.product.fit.value}`,
            Modello: row.product.style.value,
            Variante: row.product.variant.value,
            Stagione: row.product.season.slice(0, 2) + row.product.season.slice(4),
            Lavorante: newSerie.worker.description ?? 'aa',
            'Pezzi totali serie': counters.itemStatusCounts.seriesSize,
          },
          additional: {
            workerSyncCode: newSerie.worker.syncCode,
            productSku: row.product.sku,
            productSize: row.product.size.value,
            productCode: row.product.code ?? '',
            customerOrder: newSerie.customerOrder?.trim() ?? '',
            nationCode: newSerie.worker.countryCode ?? '',
          },
          descriptions: {
            Modello: row.product.style.valueDescription,
            Taglia: row.product.size.valueDescription,
            Calzata: row.product.fit.valueDescription,
            Variante: row.product.variant.valueDescription,
          },
          currentLotData: filteredLots,
          rowCode: this.isPelletteria ? undefined : row.rowCode,
        },
      }
      const causalQuantityMap = new Map<string, Map<string, number>>()
      let encodable: QuantitiesCQDto[] = []
      if (this.isPelletteria) {
        encodable = [
          {
            rowCode: newSerie.code,
            quantity:
              this.tipoCQ === 'CENTO'
                ? counters.encodableCounts.quantity === 0 && this.isWSM2
                  ? 0
                  : counters.encodableCounts.quantity
                : total,
          },
        ]
        causalQuantityMap.set(newSerie.code, new Map<string, number>())
      } else {
        if (this.tipoCQ === 'CENTO') {
          const rows = counters.encodableCounts.rows
          rows.forEach((row) => {
            const rowCode = newSerie.rows.filter(
              (r) => r.product.fit.value === row.fit && r.product.size.value === row.size
            )[0].rowCode
            if (row.quantity > 0) {
              encodable.push({
                rowCode: rowCode,
                quantity: row.quantity,
                fit: row.fit,
                size: row.size,
              })
            }
          })
        } else {
          encodable = await EncodingsCQ.getEncodableCalzature(filteredLots.map(({ id }) => id))
        }
      }
      const quantityToAdvance =
        this.getQuantityToAdvance(newSerie.code, testedPieces, encodable, toBeTested) ?? new Map<string, number>()
      const lots = newSerie.lots!.filter((lot) => lot.status === 'INSPECTED_2' || lot.status === 'READY_INSPECTION_2')
      let currentProductCounters
      if (this.tipoCQ === 'CENTO') {
        currentProductCounters =
          counters.encodableCounts.rows &&
          counters.encodableCounts.rows.filter(function (v) {
            return v.fit === row.product.fit.value && v.size === row.product.size.value
          })[0]
        if (
          (this.isPelletteria && counters.encodableCounts.quantity <= 0) ||
          (!this.isPelletteria &&
            (currentProductCounters === undefined ||
              (currentProductCounters.quantity <= 0 && serieHasTag) ||
              (!serieHasTag && this.setLotQuantity(encodable) <= 0)))
        ) {
          showToast({
            title: __(T.misc.warning),
            description: __(T.misc.items_limit_reached_wsm2),
            status: 'warning',
          })
        }
      }
      const lotQuantity = this.isPelletteria ? encodable[0].quantity : this.setLotQuantity(encodable)
      this.setState({
        serie: newSerieFormatted,
        errorSerie: undefined,
        warningText: !serieHasTag ? __(T.misc.no_tag) : undefined,
        isSerieSet: true,
        counters,
        qualitySheetData,
        lastSearchedSerieCode: code,
        hideStartReaderButton: !serieHasTag,
        lots,
        currentProductQuantity: currentProductCounters ? currentProductCounters.quantity : 0,
        testingSheetData,
        testedPieces,
        inspectorTested,
        discarded,
        toBeTested,
        isVAS,
        quantityToAdvance,
        serieHasTag,
        originalQuantity: _.cloneDeep(quantityToAdvance),
        lotQuantity,
        options: serieHasTag
          ? [
              { value: 'COLLAUDO', label: __(T.labels.testing), active: true },
              { value: 'SCARTO', label: __(T.labels.discard), active: false },
              { value: 'CANCELLAZIONE', label: __(T.labels.delete), active: false },
            ]
          : [
              { value: 'COLLAUDO', label: __(T.labels.testing), active: true },
              { value: 'SCARTO', label: __(T.labels.discard), active: false },
            ],
        rows: newSerie.rows,
        serieCode: newSerie.code,
        encodable,
        causalQuantityMap,
      })
      const totalQty = newSerie.lots.reduce(
        (acc, lot) => acc + lot.items.filter((item) => item.status === 'CQ2').length,
        0
      )
      if (
        inspectorTested + discarded === total &&
        newSerieFormatted &&
        serieHasTag &&
        ((this.tipoCQ === 'CENTO' && totalQty === counters.itemStatusCounts.seriesSize) || this.tipoCQ === 'CAMP_LOTTI')
      ) {
        if (discarded > 0) {
          showToast({
            title: __(T.misc.warning),
            description: __(T.misc.lot_has_discarded_items),
            status: 'warning',
          })
        } else {
          return await this.closeLotto()
        }
      }
      Sounds.tap()
      //in scarto non faccio partire il reader automaticamente perchè va prima selezionata la causale di scarto
      if (newSerie && startReader && serieHasTag) {
        await this.startReader()
      }
      this.clearInputRef(this.inputRef)
      return true
    } catch (error) {
      DataDogLogger.addError(error, { type: 'searchSerie' })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.serie_error),
        status: 'error',
      })
      await this.clearStatus()
      return false
    }
  }

  setLotQuantity = (encodable: QuantitiesCQDto[]) => {
    let somma = 0
    encodable.forEach((obj) => {
      if (obj.quantity > 0) somma += obj.quantity
    })
    return somma
  }

  getQuantityToAdvance = (
    serieCode: string,
    testedPieces: number,
    encodable: QuantitiesCQDto[],
    toBeTested?: number
  ) => {
    const { serieHasTag } = this.state
    const quantityToAdvance = new Map<string, number>()
    if (this.isPelletteria) {
      if (this.tipoCQ === 'CAMP_LOTTI') {
        // CQ lotti, no tag, wsm2
        quantityToAdvance.set(serieCode, testedPieces)
      } else if (this.tipoCQ === 'CENTO' && !serieHasTag && !this.isWSM2) {
        // CQ cento, no tag, no wsm2
        quantityToAdvance.set(serieCode, encodable[0].quantity)
      } else if (this.tipoCQ === 'CENTO' && !serieHasTag && this.isWSM2) {
        // CQ cento, no tag, wsm2
        quantityToAdvance.set(serieCode, toBeTested ?? 0)
      }
    } else {
      encodable.forEach((obj) => {
        const quantity = obj.quantity
        if (quantity > 0) {
          quantityToAdvance.set(obj.rowCode, quantity)
        }
      })
    }
    return quantityToAdvance
  }

  addCausaleCalz = (rowCode: string) => {
    try {
      const { rows, causalQuantityMap, causalsCount, quantityToAdvance } = this.state
      if (!rows) throw new Error(__(T.error.no_lot_selected))
      const riga = rows.filter((row) => row.rowCode === rowCode)
      if (riga.length !== 1) throw new Error(__(T.error.row_not_found))
      if ((quantityToAdvance.get(rowCode) ?? 0) <= 0) throw new Error(__(T.error.row_has_no_qty))
      if (!causalQuantityMap.has(rowCode)) {
        causalQuantityMap.set(rowCode, new Map<string, number>())
      }
      causalQuantityMap.get(rowCode)!.set('', 0)
      this.setState({ causalQuantityMap, causalsCount: causalsCount + 1 })
      this.clearInputRef(this.inputRefScarti)
    } catch (error) {
      this.clearInputRef(this.inputRefScarti)
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  showInterruptModal = async (rows: CQLot[], code: string) => {
    const modalId = 'cq-lots-interrupt'
    const rowCodes = rows.map((row) => row.code).join(', ')
    const message =
      rows.length > 1
        ? __(T.messages.lots_dont_contain_testable_items, { rowCodes })
        : __(T.messages.lot_doesnt_contain_testable_items, { rowCodes })
    return new Promise<any>((resolve) => {
      openModal({
        id: modalId,
        body: (
          <InfoModal
            title={__(T.messages.serie_confirm_interrupt)}
            subtitle={message}
            onClose={() => {
              this.interruptLotto(rows, code)
              resolve(0)
              closeModal(modalId)
              return 0
            }}
          />
        ),
      })
    })
  }

  //Mostra modale per selezione lotti
  showSelectLotsModal = async (rows: any[], lotCounts: any[]) => {
    const modalId = 'cq-lots'
    rows = rows.sort((a, b) => (a.code > b.code ? 1 : -1))
    return new Promise<any>((resolve) => {
      openModal({
        id: modalId,
        body: (
          <SelectItemModal
            title={__(T.misc.select_lot_s)}
            visible
            multiple
            forceSelect
            customBtnText={__(T.misc.confirm)}
            selected={[]}
            options={rows ?? []}
            onSelect={(items) => {
              resolve(items)
              closeModal(modalId)
            }}
            field="code"
            label="status"
            onClose={() => {
              return 0
            }}
            customRowRender={(row: CQLot, selected: boolean) => {
              const date = new Date(row.creationDate).toLocaleDateString()
              const time = new Date(row.creationDate).toLocaleTimeString()
              const dateTime = `${date} ${time}`
              const counters = lotCounts.filter((c) => c.lotId === row.id)[0]
              const pieces = counters.tested
              return (
                <KeyValueRow
                  variant="grey"
                  style={{ flex: 1, minHeight: 70 }}
                  valueStyle={{ whiteSpace: 'unset', color: row.plannedForTesting ? 'green' : ' red' }}
                  label={__(T.misc.start_date, { dateTime })}
                  value={`${row.code} - ${pieces} pz.`}
                  borderColor={selected ? '#222222' : undefined}
                  image={selected ? <Icons.CheckFilled /> : undefined}
                />
              )
            }}
            customFooter={() => {
              return (
                <Legend>
                  <LegendRow>
                    <LegendIcon color="green" />
                    <LegendText>{__(T.misc.planned_lot)}</LegendText>
                  </LegendRow>
                  <LegendRow>
                    <LegendIcon color="red" />
                    <LegendText>{__(T.misc.not_planned_lot)}</LegendText>
                  </LegendRow>
                </Legend>
              )
            }}
          />
        ),
      })
    })
  }

  startReader = async () => {
    const { options, selectedCausal } = this.state
    await QualityProvider.startReader(
      (isReading) => this.setState({ isReading }),
      (tag) => this.setState({ tag }),
      (tag) => this.verifyReadedTag(tag),
      options,
      selectedCausal
    )
  }

  verifyReadedTag = async (tag: CQTag) => {
    const { options, serie, lastReadedTag, serieHasTag, currentProductQuantity } = this.state
    const mode = options?.find((opt) => opt?.active === true)?.value
    try {
      if (lastReadedTag && lastReadedTag === tag.uid && mode === 'COLLAUDO') return this.startReader()
      if (
        mode === 'COLLAUDO' &&
        (currentProductQuantity === undefined || currentProductQuantity <= 0) &&
        !this.isPelletteria &&
        this.tipoCQ === 'CENTO' &&
        serieHasTag
      )
        throw Error(__(T.misc.items_limit_reached_wsm2))
      this.setState({
        isReading: false,
        isVerifing: true,
      })
      let res
      if (this.tipoCQ === 'CENTO') {
        res = await EncodingsCQ.verifyCQWorker({
          productionOrderId: serie!.id,
          productId: serie!.productId,
          identifiers: [{ code: tag?.uid, type: 'NFCTag' }] as any,
          configurationId: this.operation.id,
          operationType: mode,
        })
      } else if (this.tipoCQ === 'CAMP_LOTTI') {
        res = await EncodingsCQ.verifyCQInspector({
          productionOrderId: serie!.id,
          productId: serie!.productId,
          identifiers: [{ code: tag?.uid, type: 'NFCTag' }] as any,
          configurationId: this.operation.id,
          operationType: mode,
          testingLotIds: serie?.data.currentLotData?.map(({ id }) => id),
        })
        if (!res.item) throw Error(__(T.error.not_collaudated_product))
      }
      if (res.errors.length > 0) {
        QualityProvider.showErrorToast(res)
        throw Error(
          T.error[res.errors[0].errorCode.replaceAll('.', '_')]
            ? __(T.error[res.errors[0].errorCode.replaceAll('.', '_')])
            : res.errors[0].errorCode.replaceAll('.', '_')
        )
      }
      if (
        res.warnings.length > 0 &&
        !(await askUserConfirmation(
          `${
            T.error[res.warnings[0].warningCode.replaceAll('.', '_')]
              ? __(T.error[res.warnings[0].warningCode.replaceAll('.', '_')])
              : res.warnings[0].warningCode.replaceAll('.', '_')
          }`,
          __(T.misc.proceed)
        ))
      ) {
        return this.setState({ isVerifing: false })
      }
      this.setState({
        item: res.item,
        tag,
      })
      if (mode === 'SCARTO') {
        if (!serieHasTag) {
          await this.scartoItem(false)
        } else {
          return this.setState({ showScartoModal: true })
        }
      }
      this.setState({ isVerifing: false })
      if (
        mode === 'COLLAUDO' ||
        (mode === 'COLLAUDO' &&
          this.tipoCQ === 'CENTO' &&
          (!res.item ||
            res.item.status !== 'SC' ||
            (res.item.status === 'SC' &&
              (await askUserConfirmation(
                __(T.misc.warning),
                __(T.misc.item_discarded_with_causal_proceed, { causal: res.item?.causal?.description ?? '' })
              )))))
      ) {
        await this.collaudoItem(tag.uid)
      }
      if (mode === 'CANCELLAZIONE') {
        if (!res.item) throw Error(__(T.error.cannot_delete_no_item_encoded))
        await this.cancellaItem()
      }
    } catch (error) {
      this.setState({
        isReading: false,
        isVerifing: false,
      })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  collaudoItem = async (epc?: string) => {
    const { tag, serie, counters, lastSearchedSerieCode, item } = this.state
    const additionalSerieData = serie?.data.additional
    try {
      DataDogLogger.addAction('processAssociate', { serie, tag })
      this.setState({ isWriting: true })
      if (counters!.itemStatusCounts.seriesSize - counters!.itemStatusCounts.inspectorTested <= 0)
        throw Error(__(T.error.serie_limit_associate_error))
      await QualityProvider.collaudaItemEmulazione(additionalSerieData, tag, serie)
      if (this.tipoCQ === 'CAMP_LOTTI') {
        await EncodingsCQ.forceCollaudo({
          ...(item as any),
          status: 'CQ2',
          causal: undefined,
          upc: serie?.data.additional.productCode,
          productionOrderRow: item?.productionOrderRow,
          product: item?.product,
        })
      } else if (this.tipoCQ === 'CENTO') {
        await EncodingsCQ.inspectorCentoItemRead(
          serie!.data!.currentLotData![0].code,
          epc ?? '',
          this.isPelletteria ? undefined : serie!.data!.rowCode
        )
      } else {
        throw Error(__(T.error.cq_type_not_found))
      }
      this.setState({
        isWriting: false,
        isReading: false,
        lastReadedTag: tag?.uid,
      })
      Sounds.success()
      showToast({
        title: __(T.misc.success),
        description: __(T.messages.product_associated_correctly),
        status: 'success',
      })
      await this.getUpdatedSerie(lastSearchedSerieCode ?? '', this.isPelletteria)
    } catch (error) {
      DataDogLogger.addError(error, { type: 'processAssociate' })
      this.setState({ isWriting: false })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  scartoItem = async (reversible = true) => {
    const { tag, serie, selectedCausal, lastSearchedSerieCode } = this.state
    try {
      DataDogLogger.addAction('processDrop', { serie, tag, selectedCausal })
      this.setState({ showScartoModal: false, isVerifing: false, isReading: false, isWriting: true })
      if (!AppStore.emulation) {
        const res = await QualityControlAgent.writeTagSC(
          AppStore.loggedUser?.username as string,
          tag?.uid as string,
          AppStore.defaultPostazione ?? '',
          selectedCausal?.id as string
        )
        if (res?.status !== '0') throw Error(__(T.error.writing_tag_error))
      }
      if (this.tipoCQ === 'CAMP_LOTTI') {
        const response = await EncodingsCQ.dropLotInspector({
          productionOrderId: serie!.id,
          productId: serie!.productId,
          identifiers: [{ code: tag?.uid, type: 'NFCTag' }] as any,
          zoneId: AppStore.defaultZone?.id,
          configurationId: this.operation.id,
          causalId: selectedCausal?.id,
          reversible,
          testingLotIds: serie?.data.currentLotData?.map(({ id }) => id),
        })
        if (!response.success) throw Error(__(T.error.product_drop_error))
      } else if (this.tipoCQ === 'CENTO') {
        await EncodingsCQ.inspectorCentoItemRead(
          serie!.data!.currentLotData![0].code,
          tag?.uid as string,
          this.isPelletteria ? undefined : serie!.data!.rowCode,
          reversible,
          selectedCausal?.id
        )
      } else {
        throw Error(__(T.error.cq_type_not_found))
      }
      Sounds.success()
      showToast({
        title: __(T.misc.success),
        description: __(T.messages.product_associated_correctly),
        status: 'success',
      })
      this.setState({
        errorSerie: undefined,
        isWriting: false,
        isReading: false,
      })
      this.inputRef.current?.focus()
      await this.getUpdatedSerie(lastSearchedSerieCode ?? '', false)
    } catch (error) {
      DataDogLogger.addError(error, { type: 'processDrop' })
      this.setState({ isWriting: false })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  cancellaItem = async () => {
    try {
      const { tag, serie, item, lastSearchedSerieCode } = this.state
      if (await QualityProvider.checkStatusCancella(item.status)) {
        await QualityProvider.cancellaItemEmulazione((isWriting) => this.setState({ isWriting }), tag, serie, item)
        await EncodingsCQ.deleteLotInspector({
          productionOrderId: item?.productionOrderRow?.order?.id ?? serie?.id,
          productId: item?.product?.id as string,
          identifiers: [{ code: tag?.uid, type: 'NFCTag' }] as any,
          zoneId: AppStore.defaultZone?.id,
          configurationId: this.operation.id,
        })
        await QualityProvider.cancellaItem(
          (errorSerie: any, isWriting: boolean, isReading: boolean) =>
            this.setState({ errorSerie, isWriting, isReading }),
          (option) => this.changeOptions(option),
          (lastCode) => this.getUpdatedSerie(lastCode, false),
          lastSearchedSerieCode
        )
      }
    } catch (error) {
      DataDogLogger.addError(error, { type: 'processDelete' })
      this.setState({ isWriting: false })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message ?? __(T.error.WEBRESOURCE_GENERIC_ERROR),
        status: 'error',
      })
    }
  }

  stopReader = async () => {
    await QualityControlAgent.stopReader()
    await sleep(700)
    this.setState({
      isReading: false,
    })
  }

  //funzione che chiude il lotto
  closeLotto = async (lots?: CQLot[]) => {
    try {
      const {
        lastSearchedSerieCode,
        serie,
        toBeTested,
        inspectorTested,
        quantityToAdvance,
        testedPieces,
        discarded,
        causalQuantityMap,
        serieHasTag,
        lotQuantity,
        serieCode,
      } = this.state
      const lotData = lots || serie!.data!.currentLotData!
      this.setState({ isActionInProgress: true }) //settings action in progress for disable buttons click
      if (this.tipoCQ === 'CAMP_LOTTI' && !serieHasTag) {
        let items = 0
        Array.from(quantityToAdvance.entries()).forEach(([, value1]) => {
          items += value1
        })
        Array.from(causalQuantityMap.entries()).forEach(([, value1]) => {
          Array.from(value1.entries()).forEach(([, value2]) => {
            items += value2
          })
        })
        if (items < (toBeTested ?? 0)) {
          throw Error(__(T.error.tested_items_quantity_doesnt_reach_min_quantity))
        }
        if (items === 0) {
          showToast({
            title: __(T.misc.warning),
            description: __(T.messages.no_items_tested_lot_interrupted),
            status: 'warning',
          })
          await this.interruptLotto(lotData, serie!.code, true)
          return
        }
        if (this.isPelletteria) {
          await EncodingsCQ.confirmInspectorLottiNoTag(
            serie!.data!.currentLotData!.map(({ id }) => id),
            serie!.productId,
            causalQuantityMap.get(serieCode) ?? new Map<string, number>(),
            quantityToAdvance.get(serieCode) ?? 0
          )
        } else {
          await EncodingsCQ.confirmInspectorLottiNoTagCalzature(
            serie!.data!.currentLotData!.map(({ id }) => id),
            causalQuantityMap,
            quantityToAdvance,
            false
          )
        }
        await this.clearStatus()
        return showToast({
          title: __(T.misc.success),
          description: __(T.messages.lot_closed),
          status: 'success',
        })
      } else if (this.tipoCQ === 'CENTO' && !serieHasTag) {
        if (lotQuantity > 0) {
          if (this.isPelletteria) {
            if (quantityToAdvance.get(serieCode) === 0) {
              showToast({
                title: __(T.misc.warning),
                description: __(T.messages.no_items_tested_lot_interrupted),
                status: 'warning',
              })
            }
            await EncodingsCQ.confirmInspectorCentoNoTag(
              serie!.data!.currentLotData![0].id,
              serie!.productId,
              causalQuantityMap.get(serieCode) ?? new Map<string, number>(),
              quantityToAdvance.get(serieCode) ?? 0
            )
          } else {
            await EncodingsCQ.confirmInspectorLottiNoTagCalzature(
              [serie!.data!.currentLotData![0].id],
              causalQuantityMap,
              quantityToAdvance,
              true
            )
          }
        } else {
          throw Error(__(T.error.no_items_tested_cant_advance_lot))
        }
        await this.clearStatus()
        showToast({
          title: __(T.misc.success),
          description: __(T.messages.lot_closed),
          status: 'success',
        })
        return this.searchSerie(lastSearchedSerieCode ?? '')
      } else {
        if (
          this.tipoCQ !== 'CENTO' &&
          toBeTested! > inspectorTested! &&
          !(await askUserConfirmation(__(T.confirm.discrepancy_title), __(T.confirm.serie_found_discrepancy)))
        )
          return this.setState({ isActionInProgress: false }) //no action in progress, enable buttons
        if (this.tipoCQ === 'CENTO' && testedPieces === 0) {
          showToast({
            title: __(T.misc.warning),
            description: __(T.messages.no_items_tested_lot_interrupted),
            status: 'warning',
          })
          await this.interruptLotto(lotData, serie!.code, true)
          return await this.clearStatus()
        }
        const res = await EncodingsCQ.publishLotti({
          orderId: serie!.code,
          lotIds: lotData.map(({ id }) => id),
        })
        if (res.errors && res.errors.length > 0) {
          throw Error(T.error[res.errors[0].errorCode] ? __(T.error[res.errors[0].errorCode]) : res.errors[0].errorCode)
        }
      }
      await this.clearStatus()
      return showToast({
        title: __(T.misc.success),
        description: __(T.messages.lot_closed),
        status: 'success',
      })
    } catch (error) {
      DataDogLogger.addError(error, { type: 'closeSerie' })
      showToast({
        sound: false,
        title: __(T.error.error),
        description: (error as Error).message,
        status: 'error',
      })
      return this.setState({ isActionInProgress: false })
    }
  }

  //funzione che chiude il lotto
  interruptLotto = async (lotIds: CQLot[] = [], code = '', force?: boolean) => {
    try {
      const { serie, serieHasTag, causalQuantityMap, serieCode, lotQuantity, lastSearchedSerieCode } = this.state
      this.setState({ isActionInProgress: true }) //settings action in progress for disable buttons click
      let res
      if (this.tipoCQ === 'CAMP_LOTTI' && !serieHasTag) {
        if (lotQuantity === 0) throw Error(__(T.error.no_items_tested_cant_advance_lot))
        if (
          !force &&
          lotIds.length === 0 &&
          !(await askUserConfirmation(
            __(T.messages.serie_confirm_interrupt),
            __(T.messages.serie_interrupt_association_question)
          ))
        )
          return this.setState({ isActionInProgress: false }) //no action in progress, enable buttons
        res = await EncodingsCQ.interruptLottiNoTag(
          lotIds.length > 0 ? lotIds.map(({ id }) => id) : serie!.data!.currentLotData!.map(({ id }) => id),
          causalQuantityMap.get(serieCode) ?? new Map<string, number>(),
          lotQuantity
        )
      } else if (this.tipoCQ === 'CENTO') {
        if (lotQuantity === 0) throw Error(__(T.error.no_items_tested_cant_advance_lot))
        if (
          !force &&
          lotIds.length === 0 &&
          !(await askUserConfirmation(
            __(T.messages.serie_confirm_interrupt),
            __(T.messages.serie_interrupt_association_question)
          ))
        )
          return this.setState({ isActionInProgress: false }) //no action in progress, enable buttons
        res = await EncodingsCQ.interruptSeriesLotCento(serie!.data!.currentLotData![0].id, causalQuantityMap)
      } else {
        res = await EncodingsCQ.interruptLotti({
          orderId: code !== '' ? code : serie!.id,
          lotIds: lotIds.length > 0 ? lotIds.map(({ id }) => id) : serie!.data!.currentLotData!.map(({ id }) => id),
        })
      }
      if (res && res.errors && res.errors.length > 0) {
        throw Error(T.error[res.errors[0].errorCode] ? __(T.error[res.errors[0].errorCode]) : res.errors[0].errorCode)
      }
      await this.clearStatus()
      this.setState({ isActionInProgress: false })
      if (this.tipoCQ === 'CAMP_LOTTI' && !serieHasTag && !force) {
        this.searchSerie(lastSearchedSerieCode ?? '')
      }
      return showToast({
        title: __(T.misc.success),
        description: __(T.messages.lot_interrupted),
        status: 'success',
      })
    } catch (error) {
      showToast({
        sound: false,
        title: __(T.error.error),
        description: (error as Error).message,
        status: 'error',
      })
      return this.setState({ isActionInProgress: false })
    }
  }

  submitTestingSheet = async (testingSheet: Partial<TestingSheet>, isInModify: boolean) => {
    try {
      const { serie, qualitySheetData, testingSheetData } = this.state
      const { notes, attachmentFiles } = testingSheet

      DataDogLogger.addAction('submitTestingSheet', {
        serie: serie ?? 'serie is undefined',
        qualitySheetData,
        testingSheetData,
        notes,
      })

      if (!isInModify) {
        const files = {}
        attachmentFiles.map((file) =>
          Object.assign(files, { [file.name]: { content: file.base64, description: file.name } })
        )
        const newTestingSheet = {
          qualitySheetId: qualitySheetData?.id,
          orderId: serie!.id,
          notes: notes,
          attachmentFiles: files,
        }

        await EncodingsCQ.createTestingSheet(newTestingSheet)
        const res = (await EncodingsCQ.getTestingSheet(serie!.id))[0]
        this.setState({ testingSheetData: res })
      } else {
        if (!testingSheetData) throw Error(__(T.error.testing_sheet_not_set))

        const files = {}
        attachmentFiles
          .filter((file) => !!file.preview)
          .map((file) => Object.assign(files, { [file.name]: { content: file.base64, description: file.name } }))
        const newTestingSheet = {
          id: testingSheetData.id,
          inspectionNote: testingSheet.notes as string,
          attachments: testingSheetData.attachments,
          qualitySheet: testingSheetData.qualitySheet,
          code: testingSheetData.code,
        }
        await EncodingsCQ.addFilesQualitySheet(newTestingSheet.code, files)
        const res = await EncodingsCQ.updateTestingSheet(newTestingSheet)
        this.setState({ testingSheetData: res })
      }
      this.toggleSeriesNotesModal()
    } catch (error) {
      DataDogLogger.addError(error, { type: 'submitTestingSheet' })
      showToast({
        title: __(T.error.error),
        description: (error as Error).message,
        status: 'error',
      })
      this.toggleSeriesNotesModal()
    }
  }

  toggleSeriesNotesModal = () => {
    const { showSeriesNotesModal, serie } = this.state
    DataDogLogger.addAction('toggleSeriesNotesModal', {
      serie: serie ?? 'serie is undefined',
      show: !showSeriesNotesModal,
    })
    this.setState({ showSeriesNotesModal: !this.state.showSeriesNotesModal })
  }

  renderHeader = () => {
    const { options, isReading, isVerifing, isWriting, qualitySheetData, serie, isSerieSet } = this.state
    const showAntennaReadingIcon = isReading || isWriting || isVerifing
    return (
      <>
        {serie && qualitySheetData && (
          <CustomBtn onClick={this.toggleSeriesNotesModal}>{__(T.misc.serie_note)}</CustomBtn>
        )}
        {qualitySheetData && (
          <Button variant="secondary" style={{ minHeight: 55 }} onClick={this.toggleQualitySheetDetail}>
            {__(T.misc.quality_sheet)}
          </Button>
        )}
        <Spacer />
        {isSerieSet && (
          <Tab options={options} onOptionSelected={this.changeOptions} disabled={showAntennaReadingIcon} />
        )}
      </>
    )
  }

  renderBottomBar = () => {
    const { isReading, isVerifing, isWriting, hideStartReaderButton } = this.state
    const showAntennaReadingIcon = isReading || isWriting || isVerifing
    return (
      <>
        {showAntennaReadingIcon && (
          <Box row>
            <Box flex>
              <AntennaBottomControl />
            </Box>
            <Spacer />
            <Button
              title={__(T.placeholder.stop_reader)}
              onClick={this.stopReader}
              disabled={isWriting || isVerifing}
            />
          </Box>
        )}
        {!showAntennaReadingIcon && !hideStartReaderButton && (
          <Button title={__(T.placeholder.start_reader)} onClick={this.startReader} />
        )}
      </>
    )
  }

  renderInfoSerie = () => {
    const { serie, lots, counters } = this.state
    if (!serie) return
    return (
      <>
        <InfoCard item={serie!.data.values} title={__(T.labels.serie)} subtitle={serie!.code} />
        <CustomSpacer />
        <CounterContainer
          onClick={() => {
            QualityProvider.showLotsModal(lots, serie, counters).then((r) => r)
          }}
        >
          <Card title={__(T.misc.lot_info)} nomargin style={{ minWidth: 125, padding: 15 }}>
            {serie!.data!.currentLotData!.map((lot) => (
              <Counter>{lot.code}</Counter>
            ))}
            <Box style={{ flexDirection: 'row', justifyContent: 'right', marginTop: -20, zIndex: 1 }}>
              <Icons.Info style={{ alignSelf: 'center' }} width={20} height={20} />
            </Box>
          </Card>
        </CounterContainer>
      </>
    )
  }
  renderSideBar = () => {
    const { errorSerie, isReading, isWriting, isVerifing, warningText, options, isVAS, isSerieSet, serieHasTag } =
      this.state
    const isDisabled = isReading || isWriting || isVerifing
    const selectedOption = options.find((opt) => opt.active)?.value
    return (
      <>
        <Page.Sidebar style={{ overflowY: 'auto', scrollbarWidth: 'none' }}>
          <Input
            inputRef={this.inputRef}
            autoFocus={this.inputRef?.current?.value === '' && selectedOption !== 'SCARTO' && !isSerieSet}
            onChange={() => this.forceUpdate()}
            barcode
            error={errorSerie}
            placeholder={__(T.placeholder.serie_barcode)}
            onEnter={this.searchSerie}
            disabled={isDisabled}
            focusOptions={{ preventScroll: true }}
          />
          <CustomSpacer />
          {warningText && (
            <>
              <WarningText text={warningText} type="warning" p={2} />
              <CustomSpacer />
            </>
          )}
          {isVAS && (
            <>
              <WarningText text={__(T.messages.vas_serie)} type="warning" p={2} />
              <CustomSpacer />
            </>
          )}
          {this.renderInfoSerie()}
        </Page.Sidebar>
      </>
    )
  }

  renderIsReadingBox = () => {
    return (
      <Box flex center>
        <Placeholder style={{ width: 370 }}>{__(T.messages.near_product_to_reader)}</Placeholder>
      </Box>
    )
  }

  renderIsVerifingBox = () => {
    return (
      <TagReadBox bgColor="#18a0c2">
        <TagReadPlaceholder color="#fff" style={{ width: 370 }}>
          {__(T.misc.checking_dont_move)}
        </TagReadPlaceholder>
      </TagReadBox>
    )
  }

  renderIsWritingBox = () => {
    return (
      <TagReadBox bgColor="#18a0c2">
        <TagReadPlaceholder color="#fff" style={{ width: 370 }}>
          {__(T.misc.writing_dont_move)}
        </TagReadPlaceholder>
      </TagReadBox>
    )
  }

  renderScartoSelect = () => {
    const { selectedCausal, causal } = this.state
    return (
      <Box flex style={{ width: '100%' }}>
        <Select
          onSelect={(causalSel) => {
            this.setState({ selectedCausal: causalSel })
          }}
          placeholder={__(T.placeholder.drop_causal)}
          options={causal}
          config={{ value: 'id', label: 'fastId', secondaryLabel: 'description' }}
          isClearable={false}
          defaultValue={selectedCausal}
          multiLabel
        />
      </Box>
    )
  }

  renderQualitySheetModal = () => {
    const { showQualitySheetModal, serie, qualitySheetData } = this.state
    return (
      <>
        {showQualitySheetModal && (
          <QualitySheetModal
            serie={serie}
            qualitySheet={qualitySheetData}
            onClose={this.toggleQualitySheetDetail}
            visible={this.state.showQualitySheetModal}
          />
        )}
      </>
    )
  }

  renderCausale() {
    const { causal, causalsCount, serieCode } = this.state
    if (causal.length === 0 || causalsCount === 0) return null
    return (
      <QualityControlCausal
        id={serieCode}
        onDecrement={() => this.decrementQuantity(serieCode)}
        onIncrement={() => this.incrementQuantity(serieCode)}
        onQuantityChange={(causalId, quantity, oldValue) => this.onQuantityChange(causalId, quantity, oldValue)}
        checkMaxQuantity={() => this.checkMaxQuantity()}
        checkSelectedCausals={() => this.checkSelectedCausals()}
      />
    )
  }

  decrementQuantity = (rowCode: string) => {
    const { quantityToAdvance } = this.state
    if (quantityToAdvance.get(rowCode) === 0) return
    quantityToAdvance.set(rowCode, (quantityToAdvance.get(rowCode) ?? 0) - 1)
    this.setState({ quantityToAdvance })
  }

  incrementQuantity = (rowCode: string) => {
    const { quantityToAdvance } = this.state
    quantityToAdvance.set(rowCode, (quantityToAdvance.get(rowCode) ?? 0) + 1)
    this.setState({ quantityToAdvance })
  }

  onQuantityChange = (causal: string, quantity: number, oldValue: string | null, rowCode?: string) => {
    const { causalQuantityMap, serieCode } = this.state
    if (this.isPelletteria) {
      if (!causalQuantityMap.has(serieCode)) {
        causalQuantityMap.set(serieCode, new Map<string, number>())
      }
      if (oldValue) {
        causalQuantityMap.get(serieCode)?.delete(oldValue)
      }
      causalQuantityMap.get(serieCode)?.set(causal, quantity)
    } else {
      if (rowCode) {
        causalQuantityMap.get(rowCode)?.delete(oldValue ?? '')
        if (!causalQuantityMap.has(rowCode)) {
          causalQuantityMap.set(rowCode, new Map<string, number>())
        }
        causalQuantityMap.get(rowCode)?.set(causal, quantity)
      }
    }
    this.setState({ causalQuantityMap })
  }

  checkMaxQuantity = (rowCode?: string) => {
    const { causalQuantityMap, lotQuantity, isSerieSet, quantityToAdvance } = this.state
    let total = 0
    if (!isSerieSet) return true
    if (this.isPelletteria) {
      Array.from(causalQuantityMap.entries()).forEach(([, valueMap]) => {
        Array.from(valueMap.entries()).forEach(([, value]) => {
          total += value
        })
      })
      if (this.tipoCQ === 'CAMP_LOTTI') {
        return total >= lotQuantity
      }
      return lotQuantity - total === 0
    } else {
      if (!rowCode) return true
      for (const key in causalQuantityMap.get(rowCode)) {
        total += causalQuantityMap.get(rowCode)?.get(key) ?? 0
      }
      return total >= (quantityToAdvance.get(rowCode) ?? 0)
    }
  }

  checkSelectedCausals = (rowCode?: string) => {
    const { causal, causalQuantityMap, serieCode } = this.state
    let nonSelectedCausals: Causal[] = []
    if (this.isPelletteria) {
      rowCode = serieCode ?? ''
    }
    causal.forEach((c) => {
      if (!causalQuantityMap.get(rowCode ?? '')?.has(c.id) && causalQuantityMap.get(rowCode ?? '')?.get(c.id) !== 0) {
        nonSelectedCausals.push(c)
      }
    })
    return nonSelectedCausals
  }

  renderCausalsCalz = () => {
    const { causalQuantityMap, quantityToAdvance, encodable } = this.state
    if (!causalQuantityMap) return null
    return (
      <Box flex style={{ overflowY: 'auto' }}>
        {Array.from(causalQuantityMap.entries()).map(([key, valueMap]) => (
          <React.Fragment key={key}>
            <Box row>
              <Counter>
                {key} ({encodable?.find((obj) => obj.rowCode === key)!.size}/
                {encodable?.find((obj) => obj.rowCode === key)!.fit})
              </Counter>
              <CustomSpacer />
              <Counter style={{ marginLeft: 'auto', textAlign: 'right' }}>
                {__(T.misc.quantity_to_advance)}: {quantityToAdvance.get(key) ?? 0}
              </Counter>
            </Box>
            {Array.from({ length: valueMap.size }).map(() => (
              <>
                <QualityControlCausal
                  id={key}
                  onQuantityChange={(causal, quantity, oldValue) =>
                    this.onQuantityChange(causal, quantity, oldValue, key)
                  }
                  checkSelectedCausals={() => this.checkSelectedCausals(key)}
                  checkMaxQuantity={() => this.checkMaxQuantity(key)}
                  onIncrement={() => this.incrementQuantity(key)}
                  onDecrement={() => this.decrementQuantity(key)}
                />
              </>
            ))}
            <CustomSpacer />
          </React.Fragment>
        ))}
      </Box>
    )
  }

  renderInsertQuantity = () => {
    const { quantityToAdvance, options, serieCode, encodable } = this.state
    const mode = options.find((opt) => opt.active)?.value
    if (this.isPelletteria) {
      if (quantityToAdvance.get(serieCode) ?? 0 > 0) {
        return (
          <QualityControlQuantity
            quantityToAdvance={quantityToAdvance.get(serieCode) ?? 0}
            checkMaxQuantity={() => this.checkMaxQuantityToAdvance(serieCode)}
            onDecrementQuantity={() => this.onDecrementQuantity(serieCode)}
            onIncrementQuantity={() => this.onIncrementQuantity(serieCode)}
            enableIcons={mode !== 'SCARTO'}
          />
        )
      }
    } else if (mode === 'COLLAUDO') {
      return (
        <Box flex style={{ overflowY: 'auto' }}>
          {Array.from(quantityToAdvance.entries()).map(([key, value]) => (
            <React.Fragment key={key}>
              <Counter>
                {key} ({encodable?.find((obj) => obj.rowCode === key)!.size}/
                {encodable?.find((obj) => obj.rowCode === key)!.fit})
              </Counter>
              <QualityControlQuantity
                quantityToAdvance={value}
                checkMaxQuantity={() => this.checkMaxQuantityToAdvance(key)}
                onDecrementQuantity={() => this.onDecrementQuantity(key)}
                onIncrementQuantity={() => this.onIncrementQuantity(key)}
                enableIcons={mode === 'COLLAUDO'}
              />
              <CustomSpacer />
            </React.Fragment>
          ))}
        </Box>
      )
    }
  }

  checkMaxQuantityToAdvance = (rowCode: string) => {
    const { quantityToAdvance, originalQuantity } = this.state
    return (quantityToAdvance.get(rowCode) ?? 0) >= (originalQuantity.get(rowCode) ?? 0)
  }

  onDecrementQuantity = (rowCode: string) => {
    const { quantityToAdvance, lotQuantity } = this.state
    quantityToAdvance.set(rowCode, (quantityToAdvance.get(rowCode) ?? 0) - 1)
    this.setState({ quantityToAdvance, lotQuantity: lotQuantity - 1 })
  }

  onIncrementQuantity = (rowCode: string) => {
    const { quantityToAdvance, lotQuantity } = this.state
    quantityToAdvance.set(rowCode, (quantityToAdvance.get(rowCode) ?? 0) + 1)
    this.setState({ quantityToAdvance, lotQuantity: lotQuantity + 1 })
  }

  emulateTag = (tags: string[]) => {
    const tagRead = {
      errorDesc: '',
      status: '0',
      uid: tags[0],
      uuid: '045442D2B16C80045442D2B16C80',
    }
    this.verifyReadedTag(tagRead).then((r) => r)
  }

  renderCounter = () => {
    const { serieHasTag, testedPieces, discarded, toBeTested, lotQuantity, inspectorTested } = this.state
    return (
      <CounterContainer flex>
        <CounterContainer row flex>
          <Card title={__(T.misc.lot_total_pieces)} nomargin style={{ padding: 5, paddingLeft: 10, flex: 1 }}>
            {this.tipoCQ === 'CENTO' && (
              <>
                {!serieHasTag && <Counter>{lotQuantity === 0 ? '-' : lotQuantity}</Counter>}
                {serieHasTag && (
                  <Counter>{testedPieces + (discarded ?? 0) === 0 ? '-' : testedPieces + (discarded ?? 0)}</Counter>
                )}
              </>
            )}
            {this.tipoCQ === 'CAMP_LOTTI' && <Counter>{testedPieces === 0 ? '-' : testedPieces}</Counter>}
          </Card>
          <CustomSpacer />
          <Card title={__(T.placeholder.tested)} nomargin style={{ padding: 5, paddingLeft: 10, flex: 1 }}>
            <Counter>{inspectorTested === 0 ? '-' : inspectorTested}</Counter>
          </Card>
        </CounterContainer>
        <CustomSpacer />
        <CounterContainer row>
          <Card title={__(T.placeholder.dropped)} nomargin style={{ padding: 5, paddingLeft: 10, flex: 1 }}>
            <Counter>{discarded === 0 ? '-' : discarded}</Counter>
          </Card>
          <CustomSpacer />
          <Card title={__(T.misc.to_be_tested)} nomargin style={{ padding: 5, paddingLeft: 10, flex: 1 }}>
            {this.tipoCQ === 'CAMP_LOTTI' && <Counter>{toBeTested === 0 ? '-' : toBeTested}</Counter>}
            {this.tipoCQ === 'CENTO' && <Counter>{lotQuantity === 0 ? '-' : lotQuantity}</Counter>}
          </Card>
        </CounterContainer>
      </CounterContainer>
    )
  }

  render() {
    const {
      isReading,
      isVerifing,
      isWriting,
      isSerieSet,
      options,
      showScartoModal,
      showSeriesNotesModal,
      testingSheetData,
      causalsCount,
      causalQuantityMap,
      isActionInProgress,
      serieHasTag,
      serieCode,
      lotQuantity,
    } = this.state
    const disableButton = isReading || isWriting || isVerifing
    const mode = options.find((opt) => opt.active)?.value

    return (
      <Page
        title={__(T.titles.quality_control)}
        enableEmulation
        headerRight={this.renderHeader()}
        emulationFunction={this.emulateTag}
      >
        {this.renderSideBar()}
        <Page.Content>
          {isSerieSet && (
            <>
              <CounterContainer row>
                {this.renderCounter()}
                <CustomSpacer />
                <CounterContainer flex>
                  <Box flex style={{ justifyContent: 'flex-end' }}>
                    <Button
                      title={__(T.misc.confirm_lots)}
                      disabled={disableButton}
                      loading={isActionInProgress}
                      variant="primary"
                      onClick={this.closeLotto}
                    />
                  </Box>
                  <CustomSpacer />
                  <Button
                    title={__(T.misc.interrupt_lots)}
                    disabled={disableButton}
                    loading={isActionInProgress}
                    variant="error"
                    onClick={this.interruptLotto}
                  />
                </CounterContainer>
              </CounterContainer>
              <CustomSpacer />
              {!serieHasTag && (
                <>
                  {this.renderInsertQuantity()}
                  <CustomSpacer />
                </>
              )}
              {mode === 'SCARTO' && !serieHasTag && (
                <>
                  {this.isPelletteria && lotQuantity > 0 && (
                    <>
                      <Button
                        title={__(T.misc.add_discard_causal)}
                        onClick={() => {
                          let totalCausals = causalQuantityMap.get(serieCode)?.size ?? 0
                          if (!isSerieSet) return
                          if (causalsCount !== totalCausals) {
                            return
                          }
                          this.setState({ causalsCount: causalsCount + 1 })
                        }}
                      />
                      <CustomSpacer />
                      <Box flex style={{ overflowY: 'auto' }}>
                        {Array.from({ length: causalsCount }).map((_) => (
                          <>{this.renderCausale()}</>
                        ))}
                        <CustomSpacer />
                      </Box>
                    </>
                  )}
                  {!this.isPelletteria && (
                    <>
                      <Input
                        inputRef={this.inputRefScarti}
                        barcode
                        placeholder={__(T.misc.scan_size_fit_code_to_discard)}
                        onEnter={(row) => this.addCausaleCalz(row)}
                      />
                      <CustomSpacer />
                      {this.renderCausalsCalz()}
                    </>
                  )}
                </>
              )}
              {serieHasTag && !showScartoModal && (
                <>
                  {mode === 'SCARTO' && this.renderScartoSelect()}
                  <Box flex hcenter vcenter>
                    {isReading && this.renderIsReadingBox()}
                    {isVerifing && this.renderIsVerifingBox()}
                    {isWriting && this.renderIsWritingBox()}
                  </Box>
                  <Spacer />
                  {this.renderBottomBar()}
                </>
              )}
            </>
          )}
          {showScartoModal &&
            QualityProvider.renderScartoModal(
              (showScartoModal) => this.setState({ showScartoModal }),
              (reversible) => this.scartoItem(reversible)
            )}
        </Page.Content>
        {this.renderQualitySheetModal()}
        {showSeriesNotesModal && (
          <SeriesNotesModal
            onSubmitCallback={(testingSheet, updateSheet) => this.submitTestingSheet(testingSheet, updateSheet)}
            testingSheet={testingSheetData}
            onClose={this.toggleSeriesNotesModal}
            visible={this.state.showSeriesNotesModal}
          />
        )}
      </Page>
    )
  }
}

const WarningText = styled(TextBox)`
  font-size: 15px;
`

const Legend = styled(Box)`
  display: flex;
  flex-shrink: 0;
  justify-content: space-around;
  flex-direction: row;
  width: 100%;
`
const LegendRow = styled(Box)`
  display: flex;
  flex-direction: row;
`
const LegendIcon = styled.div<{ color: string }>`
  height: 20px;
  width: 20px;
  margin-right: 5px;
  ${({ color }) => `background-color: ${color}`};
`
const LegendText = styled(Box)`
  font-size: 15px;
`
const CustomBtn = styled(Button)`
  background: none;
  color: #3265c7;
  border-color: none;
  box-shadow: none;
  text-decoration: underline;
`
